module.exports = __webpack_public_path__ + "static/media/10.dc11b766.jpg";